/* prettier-ignore */

import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component,  computed,  effect,  inject,  signal } from '@angular/core';
import { MarkdownModule } from 'ngx-markdown';
import { Message } from 'src/chatbot/interface/message.interface';
import { DataChatService } from 'src/chatbot/service/dataChat.service';
import { ClipBoardIconComponent } from 'src/chatbot/icons/clipboard-icon.component';
import { SoundIconComponent } from 'src/chatbot/icons/sound-icon.component';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule} from '@angular/material/tooltip';
import { StopMusicIconComponent } from 'src/chatbot/icons/stop-icon.component';
import { TranslateModule } from '@ngx-translate/core';
import { DebugService } from 'src/app/services/debug.service';
import { AudioStorageService } from 'src/chatbot/service/audio-storage.service';
import { LinkInterceptorDirective } from 'src/app/directives/link/link.directive';
import { PlayAudioHandlerService } from 'src/chatbot/service/playAudioHandler.service';

@Component({
  selector: 'chat-bubble',
  standalone: true,
  imports: [
    CommonModule,
    MarkdownModule,
    ClipBoardIconComponent,
    SoundIconComponent,
    MatButtonModule, 
    MatTooltipModule,
    LinkInterceptorDirective,
    StopMusicIconComponent,
    TranslateModule
  ],
  templateUrl:'./chatBubble.component.html',
  styleUrls: ['./chatBubble.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChatBubbleComponent {
  private debugService = inject(DebugService);
  
  private playAudioHandlerService = inject(PlayAudioHandlerService);
  private audioStorageService = inject(AudioStorageService);  
  public dataChat = inject(DataChatService);
  public isStreaming = computed(() => this.dataChat.isStreaming());
  public isPlayingOnDemand = computed(() => this.playAudioHandlerService.isPlayingOnDemand());
  public availableAudioIds = computed(() => this.audioStorageService.availableIds());

  public messages = signal<Message[]>([]);
  private timeout: any;

  constructor() {}

  public e = effect(() => {
    if(this.dataChat.requestIsFulliled()){
      this.messages.set(this.dataChat.messages())
    }
  }, {allowSignalWrites: true})

  isUser(role: string) {
    return role === 'user';
  }

  copyToClipboard(event: any){
    const text = event.target.closest('.chat__message-wrapper')?.querySelector('.markdown').innerText;
    if (!text) 
      return;

    const tooltil = event.target.closest('.action-icons-container')?.querySelector('.copy-text');
    if (tooltil){
      tooltil.classList.add('tooptip-show');
      this.timeout = setTimeout(() => {
        tooltil.classList.remove('tooptip-show');
      }, 1000);
    }

    navigator.clipboard.writeText(text).catch((err) => {
      this.debugService.error(err, '[ChatBubbleComponent] Error copying text');
    });
  }

  // removeEmojis(text: string): string {
  //   return text.replace(
  //     /[\u{1F600}-\u{1F64F}]|[\u{1F300}-\u{1F5FF}]|[\u{1F680}-\u{1F6FF}]|[\u{2600}-\u{26FF}]|[\u{2700}-\u{27BF}]/gu,
  //     ''
  //   );
  // }

  playAudio(event){
    const target = event.currentTarget as HTMLElement; 
    const trackingId = target.getAttribute('data-tracking-id'); 
    this.playAudioHandlerService.playAudioOnDemand(trackingId);
  }

  stopAudio(){
    this.playAudioHandlerService.stopAudioOnDemand();
  }

  showAudioIcon(id){
    return this.availableAudioIds()?.includes(id);
  }

  checkPlayingOnDemand(id){
    return this.isPlayingOnDemand() === id;
  }

}
